import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import WaterUsage34_1cTable from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const WaterUsage34_1c = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("WATER_USAGE") || "Water Usage"}
        subDescription={t("WATER_USAGE_34_1C_DESC") || "Enter water usage for custom manufacturing"}
        isNormal={true}
        number={"34.1c"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`water-usage-34-1c-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <WaterUsage34_1cTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default WaterUsage34_1c;
